"use client";

import { useRef, useState } from "react";
import css from "./audio-player.module.scss";

interface IAudioPlayerProps {
  src: string;
  title: string;
}

const AudioPlayer = (props: IAudioPlayerProps) => {
  const { src, title } = props;
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  const handlePlay = () => {
    if (audioRef.current && audioRef.current.paused) {
      audioRef.current.play();
      setIsPlaying(true);
    } else if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className={css.audioPlayer}>
      <button className={css.audioPlayerButton} onClick={handlePlay}>
        <span className={`${css.audioPlayerButtonIcon} ${isPlaying ? css.isPlaying : ""}`}>{isPlaying ? "❚❚" : "▶"}</span>
      </button>
      <div className={css.audioPlayerTrack}>
        <span className={css.audioPlayerTitle}>{title}</span>
        <audio ref={audioRef} controls className={css.audioPlayerAudio}>
          <source src={src} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  );
};

export default AudioPlayer;
